// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"82":"reportedcase","594":"about"}[chunkId] || chunkId) + "." + {"82":"6dab4ce8","594":"bb17c917","647":"a6418bfa"}[chunkId] + ".css";
};